import { createSelector } from "reselect";

const getDBNSFPData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.dbnsfp_genes
    : state?.variantResult?.dbnsfp_genes;
};

const getGeneDamagePrediction = createSelector(getDBNSFPData, (result) => {
  const geneDamagePrediction = {};

  if (result && result.items && result.items[0]) {
    geneDamagePrediction.score = result.items[0].gdi;
    geneDamagePrediction.phredScore = result.items[0].gdi_phred;
    geneDamagePrediction.prediction =
      result.items[0].gene_damage_prediction?.all;
    return geneDamagePrediction;
  }
  return null;
});

export { getDBNSFPData, getGeneDamagePrediction };
